import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { Modal, Descriptions, Divider, Button, Icon, Collapse, Tabs } from "antd";
import "./style.less";
import achievement1 from "./images/achievement1.png";
import achievement2 from "./images/achievement2.png";
import achievement3 from "./images/achievement3.png";
import achievement4 from "./images/achievement4.png";
import enterprise1 from "./images/enterprise1.png";
import enterprise2 from "./images/enterprise2.png";
import enterprise3 from "./images/enterprise3.png";
import enterprise4 from "./images/enterprise4.png";
import transaction1 from "./images/transaction1.png";
import transaction2 from "./images/transaction2.png";
import transaction3 from "./images/transaction3.png";
import transaction4 from "./images/transaction4.png";
import park1 from "./images/park1.png";
import park2 from "./images/park2.png";
import park3 from "./images/park3.png";
import park4 from "./images/park4.png";
import button_close from "./images/button_close.png";
const { Panel } = Collapse;
const NAME = "evaLuateNewTool";
const App = () => {
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { title = "", show, hide, width = 1095, height = 600, ServerImg } = modalProps;
    const { TabPane } = Tabs;
    function callback(key) {
        console.log(key);
    }

    return (
        <Modal
            visible={show}
            width={width}
            height={height}
            maskClosable={false}
            onCancel={hide}
            footer={false}
            className="modal-windows"
        >
            <div className="serviceBg">
                {ServerImg == 'achievement1' &&
                    <div>
                        <p className="serviceBigTitle">科技成果信息过滤筛选择优推介模板</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={achievement1} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={achievement2} /></TabPane>
                        </Tabs>
                        <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>
                }
                {ServerImg == 'achievement3' &&
                    <div>
                        <p className="serviceBigTitle">科技成果转化全要素成熟度评价标准</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={achievement3} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={achievement4} /></TabPane>
                        </Tabs>
                        <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>
                }
                {ServerImg == 'enterprise1' &&
                    <div>
                        <p className="serviceBigTitle">企业科技创新系统能力水平评价标准</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={enterprise1} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={enterprise2} /></TabPane>
                        </Tabs>
                        <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>
                }
                {ServerImg == 'enterprise3' &&
                    <div>
                        <p className="serviceBigTitle">企业科创项目资本化成熟度评级模型</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={enterprise3} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={enterprise4} /></TabPane>
                        </Tabs>    
                        <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>}
                {ServerImg == 'transaction1' &&
                    <div>
                        <p className="serviceBigTitle">成果转化交易市场价值评估算法模型</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={transaction1} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={transaction2} /></TabPane>
                        </Tabs>
                         <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>}
                {ServerImg == 'transaction3' &&
                    <div>
                        <p className="serviceBigTitle">成果转化过程系统验证平台评价标准</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={transaction3} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={transaction4} /></TabPane>
                        </Tabs>
                         <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>
                }
                {ServerImg == 'park1' &&
                    <div>
                        <p className="serviceBigTitle">高新产业园区科创生态体系评价标准</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={park1} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={park2} /></TabPane>
                        </Tabs>
                         <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>}
                {ServerImg == 'park3' &&
                    <div>
                        <p className="serviceBigTitle">地区主导产业创新发展环境评价标准</p>
                        <Tabs type="card">
                            <TabPane tab="理论模型" key="1"><img className="serviceImg" src={park3} /></TabPane>
                            <TabPane tab="指标体系" key="2"><img className="serviceImg" src={park4} /></TabPane>
                        </Tabs>
                         <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                    </div>
                }

            </div>
        </Modal>
    );
}

export default App;